<template>
  <div id="app">
    <MobileHeader v-if="!isAdminPage" />
    <TopBanner v-if="!isAdminPage" @open-register="openFloatingRegister" />
    <main class="main-content" :class="{ 'with-header': !isAdminPage }">
      <router-view />
    </main>
    <FooterSection v-if="!isAdminPage" />
    <MobileFloatingBar v-if="!isAdminPage" ref="floatingBar" />
  </div>
</template>

<script>
import TopBanner from '@/components/TopBanner.vue'
import MobileFloatingBar from '@/components/MobileFloatingBar.vue'
import MobileHeader from '@/components/MobileHeader.vue'
import FooterSection from '@/components/FooterSection.vue'

export default {
  name: 'App',
  components: { TopBanner, MobileFloatingBar, MobileHeader, FooterSection },
  computed: {
    isAdminPage() {
      return this.$route.path.startsWith('/admin')
    }
  },
  methods: {
    openFloatingRegister() {
      if (this.$refs.floatingBar) {
        this.$refs.floatingBar.openRegister()
      }
    }
  }
}
</script>

<style>
@import url('https://cdn.jsdelivr.net/gh/orioncactus/pretendard@v1.3.9/dist/web/variable/pretendardvariable-dynamic-subset.min.css');
@import url('https://fonts.googleapis.com/css2?family=Roboto:wght@300;400;500;700&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Noto+Serif+KR:wght@400;500;600;700;900&display=swap');
@import url('https://cdn.jsdelivr.net/gh/fonts-archive/Paperlogy/subsets/Paperlogy-dynamic-subset.css');

:root {
  --font-family: 'Pretendard Variable', 'Pretendard', sans-serif;
  --font-family2: 'Roboto', sans-serif;
  --font-family4: 'Noto Serif KR', serif;
  --font-paperlogy: 'Paperlogy', sans-serif;

  /* 컬러 - 프로젝트에 맞게 수정 */
  --primary: #3f3536;
  --primary-light: #5a4d4e;
  --primary-dark: #2a2324;
  --sub-color: #f0efe2;
  --text-color: #666666;
  --white: #ffffff;
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

#app {
  font-family: var(--font-family);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: var(--text-color);
}

html, body {
  overflow-x: hidden;
  width: 100%;
}

.main-content.with-header {
  padding-top: 60px;
}

body.has-top-banner .main-content.with-header {
  padding-top: 120px;
}

#app {
  overflow-x: hidden;
  width: 100%;
}
</style>
